<template>
    <div>
<!--     规格列表 上面显示缩略图 下面显示规则值    -->
        <div class="values">
          <div v-for="(item,index) in multipleSelection" class="values-item">
            <div class="values-item-top">
              <el-image :src="item.thumbnail" :preview-src-list="[item.thumbnail]" alt="" />
            </div>
            <div class="values-item-bottom">
              <div class="values-item-bottom-left">
                <div class="values-item-bottom-left-top">
                  <span>{{ item.valueName }}</span>
                </div>
              </div>
            </div>
<!--            右上角显示删除图标-->
            <div class="values-item-bottom-right"   @click="removeUserList(item, index)">
              <span
                style="color: #FFFFFF;font-size: 14px;"

              >x</span>
            </div>
          </div>
<!--        添加规格值  与item 并列 -->
          <div class="values-item">
            <div class="values-item-top"  @click="getCommodity" style="cursor: pointer;">
<!--                加号icon -->
              <i
                style="color: #78797c;font-size: 23px;"
                class="el-icon-plus"
              ></i>
            </div>
          </div>
        </div>
        <values-list :visible.sync="dlUserShow" :spec-id="specId" :select-list.sync="dialogUserList" @on-select="onSelect"></values-list>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
import users from '../../components/users/index.vue'
import { getUser } from '@/api/demo/user'
import ValuesList from '@/components/spec/valuesList.vue'
import { getProductSpecValueListByIds } from '@/api/merchant/service/product'
export default {
  name: 'selectUser',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    ValuesList,
    users
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    specId: {
      type: [Number, String],
      default: 0
    }
  },
  watch: {
    accountIds: {
      handler: function (val, oldVal) {
        this.getSearch()
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        console.log('watch', val)
        this.accountIds = [...val]
      },
      deep: true
    }
  },
  data () {
    return {
      accountIds: [], // 用户id
      multipleSelection: [], // 用户数据
      dlUserShow: false,
      dialogUserList: [], // 弹窗用户列表
      listLoading: false
    }
  },
  created () {
    let that = this
  },
  mounted () {
    this.accountIds = [...this.value]
  },
  methods: {
    // 获取用户列表
    async getSearch () {
      if (this.accountIds.length === 0) {
        this.multipleSelection = []
        return
      }
      let that = this
      that.listLoading = true
      let res = await getProductSpecValueListByIds(this.accountIds)
      that.listLoading = false
      console.log('getUser', res)
      that.multipleSelection = res
    },
    // 清空
    cancel (form) {
      this.$refs[form].resetFields()
    },
    // 选择用户
    getCommodity () {
      this.dlUserShow = true
      this.dialogUserList = this.multipleSelection // 勾选回选
    },
    // 用户弹窗确认选择
    async onSelect (data) {
      let that = this
      if (this.multipleSelection == '') {
        data.forEach(item => {
          this.multipleSelection.push({
            specificCode: item.specificCode,
            id: item.id,
            createTime: item.createTime,
            nickname: item.nickname,
            avatar: item.avatar,
            mobile: item.mobile,
            pointAmount: item.pointAmount,
            levelName: item.levelName
          })
        })
      } else {
        data.map(item => {
          this.multipleSelection.push({
            specificCode: item.specificCode,
            id: item.id,
            createTime: item.createTime,
            nickname: item.nickname,
            avatar: item.avatar,
            mobile: item.mobile,
            pointAmount: item.pointAmount,
            levelName: item.levelName
          })
        })
      }
      this.$nextTick(function () {
        var result = []
        var obj = {}
        // 数组去重
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (!obj[this.multipleSelection[i].id]) {
            result.push(this.multipleSelection[i])
            obj[this.multipleSelection[i].id] = true
          }
        }
        this.multipleSelection = result
        this.updateList()
      })
    },
    // 删除用户
    async removeUserList (row, index) {
      let that = this
      this.multipleSelection.splice(index, 1)
      this.updateList()
    },
    updateList () {
      let accountIds = []
      this.multipleSelection.forEach(item => {
        accountIds.push(item.id)
      })
      this.accountIds = [...new Set(accountIds)]
      this.$emit('update:value', this.accountIds)
    },
    // 批量删除
    async batchDelete () {
      let that = this
      if (!that.$refs.tableRef.selection.length) {
        that.$message.error('请勾选要删除的用户')
        return
      }
      var seid = that.$refs.tableRef.selection
      let itmu = that.multipleSelection
      for (let i = 0; i < seid.length; i++) {
        for (let y = 0; y < itmu.length; y++) {
          if (JSON.stringify(itmu[y]) == JSON.stringify(seid[i])) {
            // 判断是否相等，相等就删除
            console.log(itmu[y])
            that.multipleSelection.splice(y, 1)
            // console.log(that.multipleSelection, "that.form.multipleSelection");
          }
        }
      }
      that.updateList()
    },
    // 有效时间
    dataSearch (e) {
      this.form.giftFailureTime = e
    }
  }
}
</script>
<style scope>
.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.margins {
    margin-bottom: 30px !important;
}
.values {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.values-item {
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    padding: 10px;
}
.values-item-top {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    background: linear-gradient(45deg, #f3f3f3, #fff);
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 10px;
}
.values-item-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.values-item-bottom-left {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.values-item-bottom-left-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #333;
    background: #f3f3f3;
    border-radius: 5px;
    padding: 5px 10px;
    border: 1px dashed #ccc;
    margin-bottom: 10px;
    cursor: pointer;
}
.values-item-bottom-left-bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.values-item-bottom-right {
    position: absolute;
    top: 10px;
    right: 16px;
    font-size:  20px;
    margin-left: 5px;
    cursor: pointer;
}

</style>
